import { databases } from '../lib/appwrite';
import { ID, Query } from 'appwrite';
import type { SessionDoc, TradeDoc } from '../types/appwrite';

const env = import.meta.env as any;

const DB_ID = env.VITE_APPWRITE_DB_ID as string;
const SESSIONS_COL_ID = env.VITE_APPWRITE_SESSIONS_COLLECTION_ID as string;
const TRADES_COL_ID = env.VITE_APPWRITE_TRADES_COLLECTION_ID as string;

export const createSession = async (data: SessionDoc) => {
  return await databases.createDocument(DB_ID, SESSIONS_COL_ID, ID.unique(), data);
};

export const endSession = async (docId: string, endedAtISO: string) => {
  return await databases.updateDocument(DB_ID, SESSIONS_COL_ID, docId, { status: 'ENDED', endedAt: endedAtISO });
};

export const listSessions = async () => {
  return await databases.listDocuments(DB_ID, SESSIONS_COL_ID);
};

export const createTrade = async (data: TradeDoc) => {
  return await databases.createDocument(DB_ID, TRADES_COL_ID, ID.unique(), data);
};

export const listTradesBySession = async (sessionId: string) => {
  return await databases.listDocuments(DB_ID, TRADES_COL_ID, [
    Query.equal('sessionId', sessionId),
  ]);
};